import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';

import { FullClientInterface } from '../data';
import { TestProvider } from '../providers/test.provider';
import { Transaction } from '../transaction/transaction';
import { UseCaseWithParam } from './common/use.case.with.params';

export interface GetTestDocumentsUseCaseParams {
    client: FullClientInterface;
}

@Injectable()
export class GetTestDocumentsUseCase implements UseCaseWithParam<GetTestDocumentsUseCaseParams, Observable<Transaction<any>>> {
    constructor(private testProvider: TestProvider) {}

    bind(params: GetTestDocumentsUseCaseParams): Observable<Transaction<any>> {
        return this.testProvider.documents(params.client.encryptedCode);
    }
}
